"use client";

/**
 * Purpose: Homepage final-CTA section — headline plus the "take the quiz"
 * button. No beta join option (removed with the beta program).
 * Inputs: `onTakeQuiz` click handler.
 * Outputs: JSX.
 */

import "./homeQuizCta.css";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { fadeUp } from "@lib/motion";
import RichText from "@components/text/RichText/RichText";
import HoverGradientButton from "@components/buttons/HoverGradientButton/HoverGradientButton";

interface HomeQuizCtaProps {
  onTakeQuiz: () => void;
}

export default function HomeQuizCta({ onTakeQuiz }: HomeQuizCtaProps) {
  const t = useTranslations("home.quizCta");

  return (
    <motion.div id="home-quiz-cta" className="home-quiz-cta" {...fadeUp()}>
      <p className="home-section-label">{t("label")}</p>
      <h2 className="home-quiz-cta-headline">
        <RichText translationKey="home.quizCta.headline" />
      </h2>
      <p className="home-quiz-cta-body">{t("body")}</p>
      <div className="home-quiz-cta-btns">
        <HoverGradientButton onClick={onTakeQuiz}>{t("quizBtn")}</HoverGradientButton>
      </div>
    </motion.div>
  );
}
